import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";

import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit, OnDestroy {
  public profileInitial = "";
  public profileImageUrl = "";
  public isMenuOpen = false;

  private authSubscription?: Subscription;

  constructor(public router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    this.loadSessionData();
    this.authSubscription = this.authService.authState$.subscribe(() => {
      this.loadSessionData();
      this.isMenuOpen = false;
    });
  }

  ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
  }

  get isLoggedIn(): boolean {
    return this.authService.isAuthenticated();
  }

  toggleMenu(event?: Event): void {
    event?.stopPropagation();
    if (!this.isLoggedIn) {
      return;
    }

    this.isMenuOpen = !this.isMenuOpen;
  }

  logout(event?: Event): void {
    event?.stopPropagation();
    this.isMenuOpen = false;
    this.authService.logout(true);
  }

  @HostListener("document:click")
  closeMenu(): void {
    this.isMenuOpen = false;
  }

  private loadSessionData(): void {
    const tokenData = this.authService.getDecodedToken();
    const cachedGoogleIdentity = this.authService.getCachedGoogleIdentity();
    if (!tokenData) {
      this.profileInitial = "";
      this.profileImageUrl = "";
      return;
    }

    try {
      const rawGivenName =
        tokenData["given_name"] ||
        cachedGoogleIdentity?.given_name ||
        "";
      const rawName =
        tokenData["name"] ||
        tokenData["family_name"] ||
        cachedGoogleIdentity?.name ||
        "";
      const email =
        tokenData["email"] ||
        tokenData["nameid"] ||
        cachedGoogleIdentity?.email ||
        "";
      const pictureCandidates = [
        cachedGoogleIdentity?.picture,
        tokenData["picture"],
        tokenData["image"],
        tokenData["profile_picture"],
        this.looksLikeUrl(rawGivenName) ? rawGivenName : "",
      ];
      const picture = pictureCandidates.find((candidate) => this.looksLikeUrl(candidate)) || "";
      const baseValue = rawName || (!this.looksLikeUrl(rawGivenName) ? rawGivenName : "") || email || "";

      this.profileImageUrl = picture;
      this.profileInitial = baseValue
        .toString()
        .trim()
        .charAt(0)
        .toUpperCase();
    } catch {
      this.profileInitial = "";
      this.profileImageUrl = "";
    }
  }

  onImageError(): void {
    this.profileImageUrl = "";
  }

  private looksLikeUrl(value: any): boolean {
    return typeof value === "string" && /^https?:\/\//i.test(value.trim());
  }
}
